import type { CatalogPageModelProps } from '@/components/catalog/catalog-page/catalog-page.model'
import { useCatalogPageModel } from '@/components/catalog/catalog-page/catalog-page.model'
import { CatalogPageView } from '@/components/catalog/catalog-page/catalog-page.view'

export function CatalogPageViewModel(props: CatalogPageModelProps) {
  const model = useCatalogPageModel(props)
  return <CatalogPageView {...model} />
}
